import { render, staticRenderFns } from "./AccessRight.vue?vue&type=template&id=fde89f6a"
import script from "./AccessRight.vue?vue&type=script&lang=js"
export * from "./AccessRight.vue?vue&type=script&lang=js"
import style0 from "./AccessRight.vue?vue&type=style&index=0&id=fde89f6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports